import { render, staticRenderFns } from "./edit-service.vue?vue&type=template&id=62d39a15&scoped=true&"
import script from "./edit-service.vue?vue&type=script&lang=js&"
export * from "./edit-service.vue?vue&type=script&lang=js&"
import style0 from "./edit-service.vue?vue&type=style&index=0&id=62d39a15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d39a15",
  null
  
)

export default component.exports